module.exports = __webpack_public_path__ + "static/media/area L.0622ae43.jpg";